<div class="max-w-md mx-auto mt-10 p-6 bg-white rounded-2xl shadow space-y-4">
    <h2 class="text-xl font-bold text-gray-800 text-center">
        🎨 Mise à jour du template mC-Connect™
    </h2>

    <div class="space-y-2">
        <label class="block text-sm font-medium text-gray-700">🖊️ Nom de l'appareil (device_name)</label>
        <input type="text" [(ngModel)]="deviceName" placeholder="Ex: Table 1"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-indigo-200" />
    </div>

    <div class="space-y-2">
        <label class="block text-sm font-medium text-gray-700">🏬 Point de vente</label>
        <select [(ngModel)]="selectedPosDenomination"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-indigo-200">
            <option *ngFor="let pos of posList" [value]="pos.denomination">{{ pos.denomination }}</option>
        </select>
    </div>


    <button (click)="changeDeviceAffectation()"
        class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200">
        ✅ Mettre à jour l'appareil
    </button>

    <div *ngIf="errorMessage" class="mt-4 text-red-500 text-center">
        ❌ {{ errorMessage }}
    </div>
</div>